import matchMedia from 'manager/matchMedia';



const EVENT_TAG = 'dn-mq-store';
const keys  = [];
const state = {};
const getters = {

  // 2パターンしかないので、SPじゃなければPCを返す
  group: (state, getters) => {
    return getters.sp ? 'sp' : 'pc';
  },
};



matchMedia.conditions.forEach(condition => {
  keys.push(condition.key);
  state[condition.key] = condition.mql.matches || false;
  getters[condition.key] = state => state[condition.key];
});


getters.current = state => {}

export default {
  namespaced: true,

  state,

  getters,

  actions: {
    start({commit, dispatch}) {
      keys.forEach(key => {
        matchMedia.hasAndOn(`change-${key}.${EVENT_TAG}`, isMatch => {
          if (isMatch !== undefined) {
            commit('updateKey', {key, isMatch});
          }
        });
      });
      dispatch('update');
    },

    update({commit}) {
      matchMedia.conditions.forEach(condition => {
        if (condition.mql.matches !== undefined) {
          commit('updateKey', {key: condition.key, isMatch: condition.mql.matches});
        }
      });
    },
  },

  mutations: {
    updateKey(state, {key, isMatch}) {
      state[key] = isMatch;
    },
  },
}



// WEBPACK FOOTER //
// ./src/js/store/modules/mq.js